<template>
<section class="page-voice-detail">
  <div class="thumb player">

    <div class="category-div" v-if="category_list != undefined" style="display:none;">
      <span class="cat_1" v-if="category1!=''">{{ getCategoryTitle('category1') }}</span><span class="cat_2" v-if="category2!=''">{{ getCategoryTitle('category2') }}</span>
      <span class="cat_1" v-if="category1=='' && category2==''">全て</span>
    </div>
    
    <figure><img :src="'/item/image/'+item_id" alt=""></figure>
    <div class="item-data">
      <div class="item-title">{{ content_title }}</div>
      <p class="file-name">{{ item_title }}</p>

      <div class="controller">
        <audio id="Audio" data-setup="{}" controls preload="auto" autoplay playsinline></audio>
        <div id="controller-wrapper" class="">
          <div class="audio-btn fl">
            <div id="play-pause-button"></div>
          </div>
          <div class="seek-wrap">
            <div id="time-indicator" class="fl">
              <span id="duration">0:00</span>
            </div>
            <div id="seek-slider">
            </div>
          </div>
        </div>
      </div>

      <div class="fev-button-wrap fl" v-if="contents.length">
        <button class="fev-button ccl js-tgl-btn" v-if="contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)"></button>
        <button class="fev-button ccl js-tgl-btn active" v-if="contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)"></button>
      </div>

    </div>
  </div>
  <div class="comment">
    <h3 class="in-title">{{ item_title }}</h3>

    <ul class="player-list">
      <li class="playing" v-for="(content, index) in contents" :key="index">
        <a @click="jump(content.digicon_id)" tabindex="-1" class="cvr"></a>
        <h4 class="list-title">{{ content.title }}</h4>
        <button class="fev-button js-tgl-btn" v-if="content.favorite_status==0" @click="addFavoriteList(index)"></button>
        <button class="fev-button js-tgl-btn active" v-if="content.favorite_status==1" @click="removeFavoriteList(index)"></button>
      </li>
    </ul>
  </div>
</section>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "menora-audio-player",
        props: {
            item_id: {
                type: String,
                default: '0',
            },
            digicon_id: {
                type: String,
            },
            category1: {
                type: String,
                default: '',
            },
            category1_child: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            category2_child: {
                type: String,
                default: '',
            },
            play_type: {
                type: String,
                default: 'video',
            },
        },
        data: function () {
            return {
                video: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                getAlbumInfoPath: '',
                getContentInfoPath: '',
                playStartSec: 0,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                category_list: undefined,
            }
        },
        mounted() {
            this.getAlbumInfoPath = '/purchased/digicon/detail/'+this.item_id;
            this.getContentInfoPath = '/digicon/content/';

            this.video = videojs("Audio", {html5: {
                }},
            );
            this.setVideoConfig();
            axios.default
                .post(this.getAlbumInfoPath, {type: 'content'})
                .then(response => {
                    let contents = response.data;
                    for(let i=0; i<contents.length; i++) {
                        this.$set(this.contents, i, contents[i]);
                    }
                    this.jump(this.digicon_id);
            });
            this.getCategoryList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                this.video.play();
                this.resetPlayingSec();
            },
            stop: function() {
                this.video.pause();
            },
            setVideoConfig: function() {
                this.video.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                this.video.src(path);
            },
            setDigicon: function(playing_number) {
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                axios.default
                    .get(this.getContentInfoPath+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            forward: function() {
                this.stop();
                if(this.contents.length-1 <= this.playing_number) {
                    this.finFlag = true;
                    return;
                } else {
                    this.playing_number++;
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    if(content.digicon_id == digicon_id) {
                        this.playing_number = index;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getCategoryList: function() {
                axios.default
                    .get(`/item/category/list/get?type=${this.play_type}`)
                    .then(response => {
                        this.category_list = response.data;
                    });
            },
            getCategoryTitle: function(category_type) {
                let category_num;
                let child_num;
                switch(category_type) {
                    case 'category1':
                        category_num = this.category1;
                        child_num = this.category1_child;
                        break;
                    case 'category2':
                        category_num = this.category2;
                        child_num = this.category2_child;
                        break;
                }
                if(category_num=='') {
                    return '全て';
                }
                const category_list = this.category_list[category_type];
                const category = category_list.find(element => element.id == category_num);
                if(category) {
                    const child = category['child'].find(element => element.id == child_num);
                    if(child) {
                        return child.title;
                    }
                    return category.title;
                }
                return '';
            },
        },
    }
</script>

<style scoped>
</style>
